<template>
    <footer class="footer">
        <div class="footer__top">
            <div class="container">
                <div class="justify-space-between">
                    <div class="footer__logo">
                        <div><a href="/finance"><i class="capitalist-icon-capitalist-logo-headed"></i></a></div>

                        <ul class="social-row">
                            <li><a href="https://www.instagram.com/capitalist_cap/" target="_blank"><i class="social-icon"><i class="capitalist-icon-instagram"></i></i></a></li>

                            <li><a href="https://www.facebook.com/capitalist.net/" target="_blank"><i class="social-icon"><i class="capitalist-icon-social-facebook"></i></i></a></li>

                            <li><a href="https://vk.com/capitalist_net" target="_blank"><i class="social-icon"><i class="capitalist-icon-social-vk"></i></i></a></li>

                            <li><a href="https://tele.click/Capitalist_net" target="_blank"><i class="social-icon"><i class="capitalist-icon-telegram"></i></i></a></li>

                            <li><a href="https://www.linkedin.com/company/capitalist-inc/" target="_blank">
                                <i class="social-icon capitalist-icon-linkedin-inverted"></i>
                            </a></li>
                        </ul>

                        <div style="font-size: 28px; margin-top: 15px;">
                          <a href="https://ru.trustpilot.com/review/capitalist.net" target="_blank" title="Trustpilot"><span class="capitalist-icon-logo-trustpilot"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span></a>
                        </div>
                    </div>
                    <div class="footer__menu">
                        <span class="menu__title" data-original-title="" title="">{{$t('Платежи')}}</span>
                        <ul>
                            <li><a class="link" href="/finance">{{$t('Мои счета')}}</a></li>
                            <li><a class="link" href="/cheques">{{$t('Электронные чеки')}}</a></li>
                            <li><a class="link" href="/finance/payout">{{$t('Переводы')}}</a></li>
                            <li><a class="link" href="/finance/exchange">{{$t('Конвертация')}}</a></li>
                            <li><a class="link" href="/finance/deposit">{{$t('Пополнение счета')}}</a></li>
                            <li><a class="link" href="/finance/history">{{$t('История операций')}}</a></li>
                        </ul>
                    </div>

                    <div class="footer__menu">
                        <span class="menu__title" data-original-title="" title="">{{$t('Профиль')}}</span>
                        <ul>
                            <li><a class="link" href="/security">{{$t('Настройки безопасности')}}</a></li>
                            <li><a class="link" href="/profile">{{$t('Персональная информация')}}</a></li>
                            <li><a class="link" href="/fees">{{$t('Тарифы')}}</a></li>
                            <li><a class="link" href="/settings/security/notifications">{{$t('Центр уведомлений')}}</a></li>
                            <li><a class="link" href="/profile/referral">{{$t('Реферальная программа')}}</a></li>
                        </ul>
                    </div>

                    <div class="footer__menu">
                        <span class="menu__title" data-original-title="" title="">{{$t('Поддержка')}}</span>
                        <ul>
                            <li><a class="link" href="/support/issues">{{$t('Сообщения')}}</a></li>
                            <li><a class="link" href="/contacts">{{$t('Контакты')}}</a></li>
                            <li><a class="link" href="/faq">{{$t('Частые вопросы')}}</a></li>
                            <li><a class="link" href="/developers/api">{{$t('API')}}</a></li>
                            <li><a class="link" href="/useragreement">{{$t('Пользовательское соглашение')}}</a></li>
                        </ul>
                    </div>
                    <!-- <div class="footer__menu">&nbsp;</div> -->
                </div>
            </div>
        </div>
        <div class="footer__bottom">
            <div class="container">
                <div class="footer__copyright">
                    © <a href="http://capitalist.net">Capitalist.net</a>, <span data-original-title="" title="">{{copyYear}}</span>. {{$t('Все права защищены.')}}
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'CapFooter',
  computed: {
    copyYear() {
      return `${new Date().getFullYear()}`;
    },
  },
};
</script>

<style scoped>

</style>

<i18n>
    {
        "en": {
            "Платежи": "Transfer funds",
            "Все права защищены.": "All rights reserved.",
            "Мои счета": "My accounts",
            "Электронные чеки": "Capitalist eVouchers",
            "Переводы": "Transfer funds",
            "Конвертация": "Currency exchange",
            "Пополнение счета": "Deposit",
            "История операций": "Transactions history",
            "Профиль": "Profile",
            "Настройки безопасности": "Security settings",
            "Персональная информация": "Persioan information",
            "Тарифы": "Fees",
            "Центр уведомлений": "Notifications settings",
            "Реферальная программа": "Referral program",
            "Поддержка": "Support service",
            "Сообщения": "Messages",
            "Контакты": "Contacts",
            "Частые вопросы": "Q&A",
            "API": "API",
            "Пользовательское соглашение": "User agreement"
        }
    }
</i18n>
